module.exports = __webpack_public_path__ + "media/images/icon_star-d6e18764c80b666b4b86c40b4124bc68.png";